import { getSelectedOrganization } from "../helpers/localStorage.ts";
import iframeStore from "../pages/IframeNew/iframe-store.tsx";

export const GENERAL_ORG_ID = "6f9007a7-cfd4-49b2-bf4b-be3a11e869a7";
export const PUBLICIS_ORG_ID = "81ae0fe2-72e8-4554-884a-70fa085d23c3";
export const AMANA_ORG_ID = "e46c976a-b1e9-47c9-9706-8f8d2bf0e878";
export const NVIDIA_GAMING_ORG_ID = "95655057-f746-47b5-8458-0bd994a39ea9";
export const BRIA_ORG_ID = "96c241f8-dd6a-11eb-ba80-0242ac130004";
export const ACCENTURE_ORG_ID = "6925c9b0-7dc7-4da3-b2df-5f6b26d14894";
export const TOMER_HANUKA_ORG_ID = "1e8ddc22-770f-4d87-8187-1d06904faeb2";
export const ASAF_HANUKA_ORG_ID = "c7852ae9-53e5-4885-b8a1-9f00dc278c27";
export const TAG_WORLDWIDE_ORG_ID = "77d3c43e-96be-4ecf-b102-4acf0d1abe09";
export const PURINA_ORG_ID = "bdd9e219-9075-4ba1-b60d-ff7a01c90287";
export const PAMPERS_ORG_ID = "dbd9e219-9075-4ba1-b60d-ff7a01c90286";
export const FOX_ORG_ID = "ffe14a90-1161-42f1-b937-29900f4753c8";
export const PUBLIC_GALLERY_ORG_ID = "d8c6299f-774a-4f3b-adb1-74f250e19407";
export const PUBLIC_GALLERY_ID = "425";
export const PUBLICIS_LE_PONT_UNILEVER_ORG_ID = "74b30f4d-99af-4f94-a742-4f3eb2325065";
export const MCCANN_ORG_ID = "7c188e4a-2e0b-4d62-9b42-d049f3b3fbe8";
export const BRIA_DEMOS_ORG_ID = "f359c476-394f-46c8-899e-eaeac3cba3bc";
export const BRIA_PUBLIC_ORG_ID = "44184870-b2c9-42a4-85f3-908eb4418cbc";
export const WPP_POC_ORG_ID = "a20ec961-4be2-453d-89e8-182bdcdf6353";
export const AWS_ORG_ID = "87551752-c806-4da8-b76d-bd8b5247ad01";
export const LOBLAW_ORG_ID = "5e890acc-010d-40ec-8089-fc4916d51e9f";
export const APRIMO_ORG_ID = "183b4613-2542-44ff-b2d6-75720f47aed5";
export const RAKUTEN_ORG_ID = "233c48a0-863e-4d4d-838f-b5eacd985c5e";
export const VML_ORG_ID = "babf8f22-e04d-4394-b57e-477746e8f7f6";
export const MIROGLIO_ORG_ID = "fd1afa8e-f60f-4825-8cd7-17fde29ddd5e";
export const NEXAR_ORG_ID = "42e14369-dece-458a-8d9b-83875e466a60";
export const SAFFRON_ORG_ID = "37855462-0861-4359-8595-9794f54b1517";
export const TRAILER_PARK_GROUP_ORG_ID = "f972e2fe-ae72-454a-a065-a93276f2dc6a";
export const PUBLICIS_DNAI_PROMPT_ENHANCER_ORGS_IDS = ["a7845f50-e2f0-40d4-95ba-07aaa563a5de"];
export const TOON_BOOM_ANIMATION_ORG_ID = "a779320c-019a-45f1-8b2f-994d8f360ac7";

export const isDnaiOrg = () => {
	return (
		iframeStore.isIframe() &&
		PUBLICIS_DNAI_PROMPT_ENHANCER_ORGS_IDS.includes(getSelectedOrganization()?.organization.uid ?? "")
	);
};
